import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IResponse } from '../../models/iresponse';
import { WholesaleBills } from '../../models/wholesale-bills';

@Injectable({
  providedIn: 'root'
})
export class WholesaleService {

  API_URLWholesale = `${environment.apiUrl}/Wholesale`;

  constructor(private http: HttpClient) {
  }

  getAll(body: any): Observable<IResponse<WholesaleBills>> {
    const url = this.API_URLWholesale;
    return this.http.post<IResponse<WholesaleBills>>(`${url}/GetWholesaleBills`, body);
  }

  create(body: any): Observable<any> {
    const url = this.API_URLWholesale;
    return this.http.post<any>(`${url}/CreateWholesaleBill`, body);
  }

  sendEmail(id: any): Observable<any> {
    const url = this.API_URLWholesale;
    return this.http.get<any>(`${url}/SendEmail?id=${id}`);
  }
}
